var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-6" }, [
      _c("p", { staticClass: "el-style attribute-name" }, [
        _vm._v("Description:"),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.description))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-6" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-9" }, [
          _c("p", [_vm._v(_vm._s(_vm.key))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.createdAt))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.updatedAt))]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Key:")]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Created:")]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Updated:")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }